// extracted by mini-css-extract-plugin
export default {"rating":"Yen0nQ","star":"dhI_Ai","fill":"SiXnHZ","button":"jR9XZu","size-40":"_oyZom","size-20":"gAMwUF","size-14":"FMD4Aq","size-9":"x0cZVz"};